import './mobile-navbar.css';

import { DsIcon } from '@descomplica/design-system-react';
import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';

import { LiveViewModel } from '@/presentation/screens/live/live.vm';
import { ButtonContainer } from '@/presentation/shared-components/button';

type Params = {
  toggleMenu: () => void;
  showVideo?: () => void;
  showSummary?: () => void;
};

export const MobileNavbar: React.FC<Params> = ({ toggleMenu }) => {
  //showVideo, showSummary }) => {
  const hideLandscapeChat = window.matchMedia(
    'screen and (orientation: landscape) and (max-width: 1024px)',
  ).matches;

  const vm = useViewModel(LiveViewModel);

  return (
    <div className="mobile-navbar-wrapper">
      <div className="mobile-navbar">
        {/* TODO: The mobile menu button must become a separate component in the UI library */}
        <ButtonContainer
          className="mobile-menu"
          onClick={toggleMenu}
          ariaLabel="Abrir menu lateral"
        >
          <DsIcon className="mobile-menu-icon" image="menu" />
        </ButtonContainer>
        {hideLandscapeChat && (
          <ButtonContainer
            className="mobile-menu"
            onClick={() => vm.setShowFullscreenChat(true)}
            ariaLabel="Abrir menu lateral"
          >
            <span>Mostrar chat</span>
          </ButtonContainer>
        )}
        {/*TODO: This will not be used now. In future this become a separate component in the UI library */}
        {/* <div className="mobile-switch-context">
          <ButtonContainer
            className="video-context active"
            onClick={showVideo}
            ariaLabel="Mostrar vídeo da aula"
          >
            Video
          </ButtonContainer>
          <ButtonContainer
            className="summary-context"
            onClick={showSummary}
            ariaLabel="Mostrar resumo da aula"
          >
            Resumo
          </ButtonContainer>
        </div> */}
      </div>
    </div>
  );
};
